import { EventBus } from '@primevue/core/utils';

export default EventBus();
